import React from 'react';
import { Target, AlertCircle } from 'lucide-react';

const TargetRoadmap = ({ targets, finalTotal, title = "Final Exam Targets" }) => {
  if (!targets || targets.length === 0) return null;

  // Only show grades where marks are still needed (neededMarks > 0) 
  // and discard impossible ones.
  const visibleTargets = targets
    .filter(t => t.status === 'achievable' && t.neededMarks > 0)
    .slice(0, 5);

  if (visibleTargets.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-2 mb-4">
        <Target size={18} className="text-indigo-600 dark:text-indigo-400" />
        <h3 className="text-sm font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider">{title}</h3>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {visibleTargets.map((target) => (
          <div 
            key={target.grade}
            className="p-3 rounded-2xl border border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-800/50 shadow-sm transition-all hover:border-indigo-100 dark:hover:border-indigo-900/50"
          >
            <div className="flex justify-between items-center mb-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-black text-slate-900 dark:text-white">
                  Grade {target.grade}
                </span>
                <span className="text-[10px] bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 px-1.5 py-0.5 rounded font-bold">
                  {target.points}
                </span>
              </div>
              <span className="text-[10px] font-bold text-indigo-500 dark:text-indigo-400 uppercase">Target</span>
            </div>
            
            <p className="text-xs text-slate-600 dark:text-slate-400 font-medium leading-relaxed mt-2">
              Need <span className="text-indigo-600 dark:text-indigo-400 font-bold">{target.neededMarks.toFixed(1)}</span>
              <span className="mx-1">/</span>
              {finalTotal} marks
            </p>
            
            <div className="mt-2 w-full bg-slate-100 dark:bg-slate-700 h-1 rounded-full overflow-hidden">
              <div 
                className="bg-indigo-500 dark:bg-indigo-400 h-full rounded-full transition-all duration-1000"
                style={{ width: `${Math.min(100, target.neededPercent)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      
      <p className="mt-4 text-[10px] text-slate-400 dark:text-slate-500 text-center font-medium italic">
        *Targets account for CUI's 0.5 rounding policy
      </p>
    </div>
  );
};

export default TargetRoadmap;
